<template>
  <AdblockTopbar />
  <div class="px-4 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="text__view flex flex-col justify-center text-center mb-5">
      <h1 class="font-semibold text-2xl my-5">Verbal Hooks</h1>
      <p class="leading-6 max-w-5xl mx-auto">
        Discover how to create stop-scrolling ads with these great examples of
        their first 3-seconds
      </p>
    </div>
    <div class="relative py-10 sm:py-0">
      <button
        @click="backToInitial()"
        class="cursor-pointer z-10 absolute top-0 mt-0 sm:mt-3 left-0 flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="rgb(79 70 229)"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <template v-if="verbal_hooks && totalVerbalHooks">
        <div v-if="['free'].includes(roleUser)">
          <UpgradePlans :text="'including 65+ marketing '" />
        </div>
        <div class="verbalhook__list py-4 lg:py-10 items-start mx-5">
          <VerbalHook
            v-for="verbal_hook in verbal_hooks"
            :key="verbal_hook.id"
            :data="verbal_hook"
            class="library__item border-b-2 border-grey-600"
          />
        </div>
      </template>
      <div
        class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
        v-else
      >
        <div>
          <h2 class="text-4xl font-semibold mb-4">
            There aren't Verbal Hooks 💔
          </h2>
          <p class="mb-10 text-lg">
            We recommend you check the completed library and select the awesome
            ads for you
          </p>
          <router-link to="/" class="flex justify-center">
            <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
              >Go To Ads Library</Button
            >
          </router-link>
        </div>
      </div>
      <Pagination
        :totalElements="totalVerbalHooks"
        :pageView="pageVerbalHooks"
        nameView="VerbalHooks"
      />
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import AdblockTopbar from "@/components/AdblockTopbar";
import HeaderApp from "@/components/Header";
import { useRouter } from "vue-router";
import Pagination from "@/components/Pagination";
import VerbalHook from "@/components/VerbalHook/index.vue";

export default {
  components: { HeaderApp, AdblockTopbar, Pagination, VerbalHook },
  props: {
    lock: Boolean,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      } else {
        await store.dispatch("GET_VERBAL_HOOKS");
      }
    });

    const totalVerbalHooks = computed(() => store.state.totalVerbalHooks);
    const verbal_hooks = computed(() => store.state.verbalHooks);
    const pageVerbalHooks = computed(() => store.state.pageVerbalHooks);
    const backToInitial = () => {
      router.push("/hooks");
    };

    return {
      backToInitial,
      totalVerbalHooks,
      verbal_hooks,
      pageVerbalHooks,
      VerbalHook,
    };
  },
};
</script>

<style>
.verbalhook__list {
  @apply grid gap-y-1 gap-x-2;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(17rem, 18rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}

.lock {
  filter: blur(18px);
  pointer-events: none;
}
</style>
